module.exports = __webpack_public_path__ + "public/img/icons/light-cross.svg";